import React from 'react';
import PropTypes from 'prop-types';
import { date } from '../../../dateUtils';
import { orderByStartDate } from '../../../arrayUtils';
function PastRolesDisplay(_ref) {
  var pastRoles = _ref.pastRoles,
    fullView = _ref.fullView,
    onProposalPage = _ref.onProposalPage;
  var orderedPastRoles = orderByStartDate(pastRoles);
  if (fullView) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-3"
    }, orderedPastRoles.map(function (pastRole) {
      return /*#__PURE__*/React.createElement("div", {
        key: pastRole.id,
        className: "past-role"
      }, /*#__PURE__*/React.createElement("div", {
        className: "fs-hide medium-weight"
      }, pastRole.title), /*#__PURE__*/React.createElement("div", {
        className: "fs-hide"
      }, pastRole.role), /*#__PURE__*/React.createElement("div", {
        className: "fs-hide"
      }, pastRole.company_name), !onProposalPage && /*#__PURE__*/React.createElement("div", {
        className: "fs-hide"
      }, pastRole.description), /*#__PURE__*/React.createElement("div", {
        className: "mute fs-hide"
      }, date(pastRole.start_date, pastRole.end_date, pastRole.current)));
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-3"
  }, orderedPastRoles.map(function (pastRole) {
    return /*#__PURE__*/React.createElement("div", {
      key: pastRole.id,
      className: "past-role"
    }, /*#__PURE__*/React.createElement("div", {
      className: "fs-hide medium-weight"
    }, pastRole.title), /*#__PURE__*/React.createElement("div", {
      className: "fs-hide"
    }, pastRole.role), /*#__PURE__*/React.createElement("div", {
      className: "fs-hide"
    }, pastRole.company_name), !onProposalPage && /*#__PURE__*/React.createElement("div", {
      className: "fs-hide"
    }, pastRole.description), /*#__PURE__*/React.createElement("div", {
      className: "mute fs-hide"
    }, pastRole.experience));
  }));
}
PastRolesDisplay.propTypes = {
  pastRoles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  fullView: PropTypes.bool.isRequired,
  onProposalPage: PropTypes.bool
};
PastRolesDisplay.defaultProps = {
  onProposalPage: false
};
export default PastRolesDisplay;